import axios from "axios";
//import Querystring from "querystring";
const querystring = require('querystring');

const URL1='https://cors-anywhere.herokuapp.com/https://elatukkutest.tehden.com/api/product/getProductsByProductGroup?language=en&version=1&product_group_id=';
let token=null;

export default {
  // async getEvents() {
  //   let res = await axios.get("https://cors-anywhere.herokuapp.com/http://localhost:3000/getcategories");
  //   return res.data;
  // },
  async getCats() {
    let res = await axios.get("http://localhost:3000/api/v1/getcategories");
    return res.data;
  },
  async getEventSingle(groupid) {
    let res = await axios.get("http://localhost:3000/getcategoryproducts",{
      params:{
        id:groupid

      }
    });
    return res.data;
  }, async getCatProduct(groupid) {
    let res = await axios.post("http://localhost:5001/elatukku-23ef3/us-central1/getcatdetail",{
      params:{
        group_id:groupid
      }
    });
    return res.data;
  },
  async getCategoryProduct(groupid){
let token='';

//    if(token==null)
this.gettoken().then(res=>{
  token=res.data;
});

    const AuthStr = 'Bearer '.concat(token);
    const URL=URL1.concat(groupid);
    axios.get(URL, { headers: { Authorization: AuthStr } }).then(response => {
            // If request is good...
            console.log(response.data);
            return response.data;
          })
          .catch((error) => {
            console.log('error 3 ' + error);
          });
 
  },
  async gettoken(){

    const data = {
      client_id: 'Cemet_shop',
      client_secret: 'c5LXUaauaQk6ZPShB6Zh',
      grant_type: 'password',
      username: 'Cemet_shop_uQeaxuuGv8',
      password: 'WBJWyWQDKsvLsWAE8rP2',
      redirect_uri:'https://elatukku.fi'
    };

    let res=await axios.post('https://cors-anywhere.herokuapp.com/https://elatukkutest.tehden.com/oauth/oaclient/token',querystring.stringify(data)).
    then(response=>{
      token=response.data.access_token;   
      return token;   
    }).catch((error)=>{
      console.log('error: ' + error);
    });
  }

 





  // async getEventSingle(groupid, accessToken) {
  //   let res = await axios.get("http://localhost:3000/getcategoryproducts" + groupid, {
  //       headers: {
  //           Authorization: `Bearer ${accessToken}`
  //       }
  //   });
  //   return res.data;
  // }
}


// WEBPACK FOOTER //
// ./src/services/EventService.js